import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { ProductGroupApiResponse } from '.';
import useSiteLeadStore from '@store/siteLeadStore';

export const useKAESSProductListQuery = (membershipno?: string): IQueryResponse<ProductGroupApiResponse> => {
	const { grade, reason, type_of_contract, glue } = useSiteLeadStore();

	const fetchTaskListProductsData = async (): Promise<ProductGroupApiResponse> => {
		const url = `${APICONFIG.KAESS_PRODUCT_LIST}`;
		return await APIService.getData<ProductGroupApiResponse>(url, {
			grade: grade ?? '',
			reason: reason ?? '',
			type_of_contract: type_of_contract ?? '',
			glue: glue?.toLowerCase() ?? '',
			membershipno: membershipno ?? '',
		});
	};

	const { data, error, isLoading, isPending, isFetching } = useQuery({
		queryKey: ['productListKAESS'],
		queryFn: fetchTaskListProductsData,
		refetchOnWindowFocus: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
	};
};
